import { SubscribeRequestData } from '../../../typings';

import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function putSubscribeCourse(data: SubscribeRequestData): Promise<void> {
    const { apiPutSubscribeCourse } = apiConfig.getStaticUrls();

    return postFetch(apiPutSubscribeCourse, { data });
}

